
import React from 'react';
import { useNavigate } from 'react-router-dom';

interface ErrorBoundaryProps {
  error: Error | null;
  resetError: () => void;
}

/**
 * Компонент для отображения ошибок при рендеринге маршрутов
 */
export const ErrorBoundary: React.FC<ErrorBoundaryProps> = ({ error, resetError }) => {
  const navigate = useNavigate();
  
  if (!error) return null;
  
  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-4">
      <h1 className="text-2xl font-bold mb-4">Что-то пошло не так</h1>
      <p className="text-muted-foreground mb-4">Произошла ошибка при загрузке страницы</p>
      <button 
        className="px-4 py-2 bg-primary text-white rounded-md hover:bg-primary/90"
        onClick={() => {
          resetError();
          navigate('/');
        }}
      >
        Вернуться на главную
      </button>
    </div>
  );
};
